export default "__VITE_PUBLIC_ASSET__3a860a5a__"